var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _vm.barVisible
      ? _c("div", { staticClass: "signup__bar" }, [
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-24" }, [
                _c("div", { staticClass: "bar__inner" }, [
                  _c("div", [
                    _c("strong", [
                      _vm._v("Are You A Water-Right Contractor? "),
                    ]),
                    _vm._v(
                      "Sign up\n              for contractor tools and resources.\n            "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "btn",
                      attrs: { href: "/for-contractors/#contractor__signup" },
                    },
                    [_vm._v("Sign Up Now")]
                  ),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "bar__close",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        _vm.barVisible = false
                      },
                    },
                  }),
                ]),
              ]),
            ]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }